module.exports = __webpack_public_path__ + "img/rusradio.0af4503d.svg";